import { Skeleton } from '@eureca/ui';
import { ConsultantsMenu } from '@/shared/consultants-menu/ConsultantsMenu';
import { RouteIcon } from './icons';

/**
 * Skeleton exibido enquanto o `GET /jobs/:id` está em voo na primeira
 * carga da subseção Fluxo. Mantém o layout (header + 4 phase cards
 * horizontais + rodapé) para evitar shift de paint quando os dados chegam.
 */
export function JobFlowLoadingFallback() {
  return (
    <div className="flex min-h-dvh flex-row bg-muted">
      <ConsultantsMenu activeId="jobs" />

      <main className="flex flex-1 flex-col gap-8 bg-card px-4 pt-8 pb-16 md:px-8">
        <div
          aria-busy="true"
          aria-label="Carregando fluxo"
          data-testid="job-flow-loading"
          className="flex flex-col gap-8"
        >
          <header className="flex flex-col gap-2">
            <div className="flex flex-row items-center gap-2">
              <div className="flex size-8 items-center justify-center rounded-md bg-secondary text-secondary-foreground">
                <RouteIcon className="size-4" />
              </div>
              <Skeleton className="h-9 w-64" />
            </div>
            <Skeleton className="h-6 w-24" />
          </header>

          <ol className="flex flex-row items-stretch gap-5">
            {Array.from({ length: 4 }).map((_, i) => (
              <li key={i} className="flex w-[305px] shrink-0 flex-col gap-5">
                <Skeleton className="h-14 w-full rounded-lg" />
                <Skeleton className="h-8 w-full" />
              </li>
            ))}
          </ol>
        </div>
      </main>
    </div>
  );
}
